import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectGroup: {
		id: 'business-list.list-view.group-item.select-group-checkbox.select-group',
		defaultMessage: 'Select group',
		description: 'Hidden accessibility label for bulk select all in a group',
	},
});
